import { SVGProps } from 'react';

const CheckboxUnchecked = ({
  props,
  fill = 'currentColor',
  size = 24,
}: {
  props?: SVGProps<SVGSVGElement>;
  fill?: string;
  size?: string | number;
}) => (
  <svg width={size} height={size} viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.5 1.99998C4.01472 1.99998 2 4.0147 2 6.49998V15.5C2 17.9853 4.01472 20 6.5 20H15.5C17.9853 20 20 17.9853 20 15.5V6.49998C20 4.0147 17.9853 1.99998 15.5 1.99998H6.5ZM6.95 3.34998C4.96177 3.34998 3.35 4.96176 3.35 6.94998V15.05C3.35 17.0382 4.96177 18.65 6.95 18.65H15.05C17.0382 18.65 18.65 17.0382 18.65 15.05V6.94998C18.65 4.96176 17.0382 3.34998 15.05 3.34998H6.95Z"
      fill={fill}
    />
  </svg>
);

export default CheckboxUnchecked;
